import { defineMessages } from 'react-intl-next';
export default defineMessages({
  hubLoadingSpinnerLabel: {
    id: 'company-hub.hub.loading-spinner-label',
    defaultMessage: 'Loading hub',
    description: 'Label for the hub loading spinner'
  }
});